export default __webpack_public_path__ + "static/media/145-customer-service.025b917d.svg";